var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavenow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 37.4491H4.66667C3.69421 37.4491 2.76158 36.9973 2.07394 36.1931C1.38631 35.3889 1 34.2982 1 33.1609V13.8643C1 12.727 1.38631 11.6363 2.07394 10.8321C2.76158 10.028 3.69421 9.57617 4.66667 9.57617H30.3333C31.3058 9.57617 32.2384 10.028 32.9261 10.8321C33.6137 11.6363 34 12.727 34 13.8643V33.1609C34 34.2982 33.6137 35.3889 32.9261 36.1931C32.2384 36.9973 31.3058 37.4491 30.3333 37.4491Z",
    stroke: "#059157",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 9.57629V2.28644C8.3335 1.94526 8.44939 1.61805 8.65568 1.37679C8.86197 1.13554 9.14176 1 9.4335 1H25.5668C25.7113 1 25.8543 1.03327 25.9878 1.09792C26.1212 1.16257 26.2425 1.25733 26.3446 1.37679C26.4468 1.49625 26.5278 1.63806 26.5831 1.79414C26.6384 1.95022 26.6668 2.11751 26.6668 2.28644V9.57629",
    stroke: "#059157",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 1V9.57629",
    stroke: "#059157",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1V9.57629",
    stroke: "#059157",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7502 24.5845C25.507 24.5845 25.2739 24.4716 25.102 24.2705C24.9301 24.0695 24.8335 23.7968 24.8335 23.5125C24.8335 23.2281 24.9301 22.9555 25.102 22.7544C25.2739 22.5534 25.507 22.4404 25.7502 22.4404C25.9933 22.4404 26.2264 22.5534 26.3983 22.7544C26.5703 22.9555 26.6668 23.2281 26.6668 23.5125C26.6668 23.7968 26.5703 24.0695 26.3983 24.2705C26.2264 24.4716 25.9933 24.5845 25.7502 24.5845Z",
    fill: "black",
    stroke: "#059157",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavenow);
export default __webpack_public_path__ + "static/media/savenow.39e0cfd2b11ee7d032ae922ad16837d5.svg";
export { ForwardRef as ReactComponent };